export const SuggestedSectionTitle = ({ children }: { children: string }): React.ReactElement => {
  return <h3 className="text-white font-evogria text-3xl lg:text-5xl uppercase">{children}</h3>
}
